import { initialState } from "../../shared/state/reducer";
import { IADPState } from "../../shared/typings";

export const InternetInitialState:IADPState = {
    ...initialState,
    appState: {
        ...initialState.appState,
        launchMode: "Internet",
        currentPhase: "Initilizing",
        appPhases: [
            {
              
                name: "NetworkCheck",
                status: "NotStarted"
            },
            {
            
                name: "DateTimeCheck",
                status: "NotStarted"
            },
            {
         
                name: "UpdateCheck",
                status: "NotStarted"
            },
            {
        
                name: "CodeVerification",
                status: "NotStarted"
            },
            {
          
                name: "DeviceValidation",
                status: "NotStarted"
            },
            {
    
                name: "TransitionToSCI",
                status: "NotStarted"
            }
        ]
    },
    sessionState: {
        ...initialState.sessionState,
        selectedAssessmentMode: "online",
        connectionType: "Internet"
    },
    deviceState: {
        ...initialState.deviceState,
        deviceType: "SBE"
    }
}